// LogRocket's redux middleware records every action and state snapshot.
// Keep passwords typed into the user form out of those recordings.
export const REDACTED = '[redacted]';

const SAVE_USER = 'zen/UserForm/SAVE_USER';
const PASSWORD_FIELDS = ['password', 'confirm_password'];

const redact = (obj) => {
  if (!obj || !PASSWORD_FIELDS.some((key) => obj[key] !== undefined)) { return obj; }
  const copy = { ...obj };
  PASSWORD_FIELDS.forEach((key) => {
    if (copy[key] !== undefined) { copy[key] = REDACTED; }
  });
  return copy;
};

export const actionSanitizer = (action) => {
  if (!action || action.type !== SAVE_USER || !action.payload || !action.payload.payload) { return action; }
  const payload = redact(action.payload.payload);
  if (payload === action.payload.payload) { return action; }
  return { ...action, payload: { ...action.payload, payload } };
};

export const stateSanitizer = (state) => {
  const form = state && state.UserForm;
  if (!form || !form.user) { return state; }
  const user = redact(form.user);
  if (user === form.user) { return state; }
  return { ...state, UserForm: { ...form, user } };
};
